import { render } from "./InfoRealTimePage.vue?vue&type=template&id=6e9c3e66&ts=true"
import script from "./InfoRealTimePage.vue?vue&type=script&lang=ts"
export * from "./InfoRealTimePage.vue?vue&type=script&lang=ts"

import "./InfoRealTimePage.vue?vue&type=style&index=0&id=6e9c3e66&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Dashboard_YHCT/Dashboard_FE_YHCT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__